import * as React from 'react';
import './courseList.module.scss';
export const CourseList = ({ children }) => (
    <div styleName="course-list-wrapper">
        <div styleName="course-list">{children}</div>
    </div>
);
